import { Dispatch } from "redux";
import request from "../../util/request";
import actions from "../../util/actions";
import errorHandler from "../../util/error-handler";

export const getProjects = (search: string, page: number, per_page: number) => {
  return (dispatch: Dispatch): void => {
    dispatch({
      type: actions.PROJECTS_HTTP_LOADING
    });

    request({
      method: "get",
      pathname: "getProjects",
      params: { search, page, per_page }
    })
      .then((response) => {
        dispatch({
          type: actions.PROJECTS_HTTP_COMPLETE,
          payload: {
            response: response
          }
        });

        dispatch({
          type: actions.SET_PROJECTS_DETAILS,
          payload: {
            ...response.data.content
          }
        });
      })
      .catch((error) => {
        errorHandler(actions.PROJECTS_HTTP_ERROR, error, dispatch);
      });
  };
};
